<div class="header">
    <div class="header-cont tables-with-input">
        <h2>{{ 'admin_to_approve.title_poi' | translate }}</h2>
        <mat-form-field appearance="outline">
            <mat-label>{{ 'admin_to_approve.search_label' | translate }}</mat-label>
            <input matInput (keyup)="applyFilterPoi($event)" class="input-filter"
                [placeholder]="'placeholder' | translate">
            <mat-icon *ngIf="!loadingPoi; else loadingList" matSuffix>search</mat-icon>
            <ng-template #loadingList>
              <mat-progress-spinner
                  matSuffix
                  color="primary"
                  mode="indeterminate"
                  [diameter]="24">
              </mat-progress-spinner>
            </ng-template>
        </mat-form-field>
    </div>
</div>

<div class="admin-table">
    <table mat-table [dataSource]="dataSourcePoi">

        <!-- POI name Column -->
        <ng-container matColumnDef="poi_name">
            <th mat-header-cell *matHeaderCellDef> {{ 'admin_to_approve.columns_poi.poi' | translate }} </th>
            <td mat-cell *matCellDef="let row">
                {{row.poi_name[current_lang]}}
            </td>
        </ng-container>

        <!-- User Column -->
        <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef> {{ 'admin_to_approve.columns_poi.user' | translate }} </th>
            <td mat-cell *matCellDef="let row">
                {{returnUserName(row.user_id, user_list)}}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsPoi;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsPoi;"
            [routerLink]="['/lista-da-approvare/poi/'+row.id]">
        </tr>
    </table>

    <mat-paginator #poiPaginator class="mat-paginator-sticky" [length]="poi_list_total" [pageSize]="poi_list_size">
    </mat-paginator>
</div>

<div class="header">
    <div class="header-cont tables-with-input margin-small top">
        <h2>{{ 'admin_to_approve.title_itin' | translate }}</h2>
        <mat-form-field appearance="outline">
            <mat-label>{{ 'admin_to_approve.search_label' | translate }}</mat-label>
            <input matInput (keyup)="applyFilterItin($event)" class="input-filter"
                [placeholder]="'placeholder' | translate">
            <mat-icon *ngIf="!loadingItin; else loadingList" matSuffix>search</mat-icon>
            <ng-template #loadingList>
              <mat-progress-spinner
                  matSuffix
                  color="primary"
                  mode="indeterminate"
                  [diameter]="24">
              </mat-progress-spinner>
            </ng-template>
        </mat-form-field>
    </div>
</div>

<div class="admin-table">
    <table mat-table [dataSource]="dataSourceItin">

        <!-- Itin name Column -->
        <ng-container matColumnDef="itin_name">
            <th mat-header-cell *matHeaderCellDef> {{ 'admin_to_approve.columns_itin.itin' | translate }} </th>
            <td mat-cell *matCellDef="let row">
                {{row.itin_name[current_lang]}}
            </td>
        </ng-container>

        <!-- User Column -->
        <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef> {{ 'admin_to_approve.columns_itin.user' | translate }} </th>
            <td mat-cell *matCellDef="let row">
                {{returnUserName(row.user_id, user_list)}}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsItin;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsItin;"
            [routerLink]="['/lista-da-approvare/itinerari/'+row.id]">
        </tr>
    </table>

    <mat-paginator #itinPaginator class="mat-paginator-sticky" [pageSize]="itin_list_size" [length]="itin_list_total">
    </mat-paginator>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
